import {AxiosError} from 'axios';
import {GET_NON_NATIONAL_EXAM_WITHDRAWAL_SUMMARY_QUERY_KEY} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {GET_NON_NATIONAL_EXAM_WITHDRAWAL_SUMMARY_URL} from '../../constants/apiUrls';
import {useCustomQuery} from '../utils/useCustomQuery';
import {AddressItem} from '../../api/candidate/profile/@candidate/models';
import {EntityModelList} from '../../api/candidate/exam/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface WithdrawalSummaryResponse {
  applicationId: string;
  applicationDateTime: string;
  lastUpdatedDateTime: string;
  status: string;
  examLevel: string;
  levelSeekingAdmissionTo: string;
  reasonSelected: string;
  specifiedReason: string;
  fileNames: EntityModelList[];
  candidateDetails: {
    statutoryName: string;
    hanyuPinyinName: string;
    idType: string;
    nricFin: string;
    email: string;
    nationality: string;
    citizenship: string;
    schoolName: string;
    mailingAddress: AddressItem;
    foreignAddress1: string;
    foreignAddress2: string;
    foreignAddress3: string;
  };
  allowedAddDocuments: boolean;
  examYear: number;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: WithdrawalSummaryResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalExamWithdrawalSummary = ({uuid, onSuccess, onError}: Input) => {
  const getNonNationalExamWithdrawalSummary = async () => {
    const res = await axiosClient.get<WithdrawalSummaryResponse>(
        GET_NON_NATIONAL_EXAM_WITHDRAWAL_SUMMARY_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(
      GET_NON_NATIONAL_EXAM_WITHDRAWAL_SUMMARY_QUERY_KEY,
      getNonNationalExamWithdrawalSummary,
      {
        onSuccess,
        onError,
      }
  );
};
